import { SVGProps, Ref, forwardRef } from 'react';

export const TrolleyFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m24 1.78-.466 1.74-4.904-1.315-3.82 14.259a4 4 0 1 1-5.876 3.392L4.97 18.795c-.935-.25-1.55-.414-2.02-.475-.445-.057-.626-.002-.746.067s-.259.198-.432.612l-.013.037-.012.033L0 18.601q.055-.155.113-.295c.25-.6.594-1.134 1.192-1.479.597-.345 1.23-.375 1.875-.292q.196.026.41.067l1.59-5.93.016-.06c.352-1.314.64-2.389.98-3.206.357-.853.82-1.552 1.597-2 .777-.45 1.614-.5 2.532-.383.882.114 1.962.404 3.285.758l.04.011 2.03.544L17.355 0zM13.501 17.87a2.2 2.2 0 1 0-1.14 4.252 2.2 2.2 0 0 0 1.14-4.252"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrolleyFilledSize24Glyph.displayName = 'TrolleyFilledSize24Glyph';
